import { theme } from "@/lib/theme";

interface SearchBarProps {
  value: string;
  onSearch: (query: string) => void;
}

export default function SearchBar({ value, onSearch }: SearchBarProps) {
  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="relative">
        <div className="absolute inset-0 bg-gray-900 dark:bg-gray-700 rounded-xl translate-y-2 translate-x-2" />
        <input
          type="search"
          value={value}
          placeholder="Search episodes by title or description..."
          className={`relative z-10 w-full px-6 py-3 bg-white dark:bg-gray-800 border-3 border-gray-900 dark:border-gray-700 rounded-xl text-lg text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:ring-2 ${theme.ring.primaryOrange} focus:border-gray-900 dark:focus:border-gray-700 transition-transform hover:-translate-y-1 hover:-translate-x-1`}
          onChange={event => onSearch(event.target.value)}
        />
      </div>
    </div>
  );
}
